import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Box, Typography, Slide } from '@mui/material';
import { styled } from '@mui/system';
import useMediaQuery from '@mui/material/useMediaQuery';

// Define the LogoIcon with dynamic stroke/fill based on hover
const LogoIcon = ({ isHovered, ...props }) => (
    <svg width="148" height="40" viewBox="0 0 148 40" fill="none" xmlns="http://www.w3.org/2000/svg"
         style={{transform: 'scale(0.7)'}}>

        <path
            d="M147 21.5L122 30.7126L128.646 21.5M147 21.5L128.646 21.5M147 21.5L126.049 32L126.806 28.9423M147 21.5L122 12.2874L128.646 21.5M147 21.5L126.049 11L126.806 14.0584"
            stroke="#DC5454" stroke-linecap="round" stroke-linejoin="round"
        />

        <path
            d="M11.375 31C11.0717 31 10.815 30.9067 10.605 30.72C10.4183 30.51 10.325 30.2533 10.325 29.95V3.665H12.425V29.95C12.425 30.2533 12.32 30.51 12.11 30.72C11.9233 30.9067 11.6783 31 11.375 31ZM1.47 5.555C1.19 5.555 0.956667 5.47333 0.77 5.31C0.606667 5.12333 0.525 4.89 0.525 4.61C0.525 4.33 0.606667 4.10833 0.77 3.945C0.956667 3.75833 1.19 3.665 1.47 3.665H21.28C21.56 3.665 21.7817 3.75833 21.945 3.945C22.1317 4.10833 22.225 4.33 22.225 4.61C22.225 4.89 22.1317 5.12333 21.945 5.31C21.7817 5.47333 21.56 5.555 21.28 5.555H1.47ZM21.726 19.31C21.866 17.8167 22.2743 16.4983 22.951 15.355C23.6276 14.1883 24.5026 13.2783 25.576 12.625C26.6493 11.9717 27.8393 11.645 29.146 11.645C30.0326 11.645 30.721 11.75 31.211 11.96C31.701 12.17 31.8876 12.5433 31.771 13.08C31.701 13.43 31.5376 13.64 31.281 13.71C31.0243 13.78 30.7093 13.7917 30.336 13.745C29.986 13.675 29.5893 13.64 29.146 13.64C27.9793 13.64 26.941 13.885 26.031 14.375C25.121 14.865 24.4093 15.5417 23.896 16.405C23.3826 17.245 23.126 18.2133 23.126 19.31H21.726ZM22.076 31C21.7726 31 21.516 30.9067 21.306 30.72C21.1193 30.51 21.026 30.2533 21.026 29.95V12.905C21.026 12.5783 21.1193 12.3217 21.306 12.135C21.516 11.9483 21.7726 11.855 22.076 11.855C22.4026 11.855 22.6593 11.9483 22.846 12.135C23.0326 12.3217 23.126 12.5783 23.126 12.905V29.95C23.126 30.2533 23.0326 30.51 22.846 30.72C22.6593 30.9067 22.4026 31 22.076 31ZM43.7213 31.21C41.8546 31.21 40.1746 30.79 38.6813 29.95C37.2113 29.0867 36.0446 27.92 35.1813 26.45C34.3413 24.9567 33.9213 23.2883 33.9213 21.445C33.9213 19.5783 34.3413 17.91 35.1813 16.44C36.0446 14.9467 37.2113 13.78 38.6813 12.94C40.1746 12.0767 41.8546 11.645 43.7213 11.645C45.588 11.645 47.2563 12.0767 48.7263 12.94C50.1963 13.78 51.3513 14.9467 52.1913 16.44C53.0546 17.91 53.4863 19.5783 53.4863 21.445L52.6113 22.845C52.6113 24.4317 52.2146 25.855 51.4213 27.115C50.6513 28.375 49.6013 29.3783 48.2713 30.125C46.9413 30.8483 45.4246 31.21 43.7213 31.21ZM43.7213 29.25C45.1913 29.25 46.498 28.9117 47.6413 28.235C48.808 27.535 49.718 26.6017 50.3713 25.435C51.048 24.245 51.3863 22.915 51.3863 21.445C51.3863 19.9517 51.048 18.6217 50.3713 17.455C49.718 16.265 48.808 15.3317 47.6413 14.655C46.498 13.955 45.1913 13.605 43.7213 13.605C42.2746 13.605 40.968 13.955 39.8013 14.655C38.6346 15.3317 37.713 16.265 37.0363 17.455C36.3596 18.6217 36.0213 19.9517 36.0213 21.445C36.0213 22.915 36.3596 24.245 37.0363 25.435C37.713 26.6017 38.6346 27.535 39.8013 28.235C40.968 28.9117 42.2746 29.25 43.7213 29.25ZM52.4363 31C52.133 31 51.8763 30.9067 51.6663 30.72C51.4796 30.51 51.3863 30.2533 51.3863 29.95V23.545L52.0513 21.445H53.4863V29.95C53.4863 30.2533 53.393 30.51 53.2063 30.72C53.0196 30.9067 52.763 31 52.4363 31ZM64.2466 31.035C63.8033 31.035 63.4766 30.79 63.2666 30.3L55.2866 13.22C55.1933 12.9633 55.1933 12.7183 55.2866 12.485C55.3799 12.2283 55.5549 12.0417 55.8116 11.925C56.0683 11.8083 56.3133 11.7967 56.5466 11.89C56.8033 11.9833 56.9899 12.1583 57.1066 12.415L64.9466 29.355H63.6516L71.3516 12.38C71.4683 12.1233 71.6549 11.9483 71.9116 11.855C72.1916 11.7617 72.4599 11.7733 72.7166 11.89C72.9733 12.0067 73.1483 12.1933 73.2416 12.45C73.3583 12.6833 73.3583 12.9283 73.2416 13.185L65.3666 30.3C65.1333 30.79 64.7599 31.035 64.2466 31.035ZM80.334 39.295C80.194 39.295 80.0307 39.26 79.844 39.19C79.214 38.9333 79.039 38.5017 79.319 37.895L91.079 12.415C91.359 11.8317 91.7907 11.6567 92.374 11.89C93.004 12.1467 93.179 12.5783 92.899 13.185L81.139 38.665C80.929 39.085 80.6607 39.295 80.334 39.295ZM84.044 30.545C83.7407 30.685 83.4724 30.72 83.239 30.65C83.0057 30.58 82.819 30.3933 82.679 30.09L75.014 13.29C74.874 12.9867 74.839 12.7183 74.909 12.485C74.979 12.2517 75.1657 12.065 75.469 11.925C75.7724 11.785 76.0407 11.75 76.274 11.82C76.5074 11.89 76.694 12.0767 76.834 12.38L84.499 29.18C84.639 29.4833 84.674 29.7517 84.604 29.985C84.534 30.2183 84.3474 30.405 84.044 30.545ZM109.829 31C109.549 31 109.327 30.9533 109.164 30.86C109.001 30.7433 108.826 30.5683 108.639 30.335L102.619 22.355L101.744 21.69L95.6189 13.605C95.4322 13.3717 95.3506 13.1267 95.3739 12.87C95.3972 12.59 95.5022 12.3567 95.6889 12.17C95.8756 11.96 96.1206 11.855 96.4239 11.855C96.7272 11.855 96.9839 11.96 97.1939 12.17L103.039 19.94L103.984 20.675L110.459 29.285C110.762 29.6583 110.867 29.9733 110.774 30.23C110.704 30.4867 110.564 30.685 110.354 30.825C110.144 30.9417 109.969 31 109.829 31ZM95.6539 31C95.3506 31 95.1056 30.9067 94.9189 30.72C94.7322 30.5333 94.6272 30.3117 94.6039 30.055C94.5806 29.775 94.6622 29.5183 94.8489 29.285L101.639 20.85L102.864 22.39L96.3889 30.685C96.2489 30.895 96.0039 31 95.6539 31ZM103.529 21.83L102.269 20.29L108.639 12.485C108.826 12.275 109.001 12.1233 109.164 12.03C109.351 11.9133 109.537 11.855 109.724 11.855C110.051 11.855 110.296 11.96 110.459 12.17C110.622 12.3567 110.704 12.59 110.704 12.87C110.704 13.1267 110.611 13.3717 110.424 13.605L103.529 21.83Z"
            fill={isHovered ? "#DC5454" : "#383838"}
        />
    </svg>
);

// Styled components
const HeaderContainer = styled(AppBar)({
    boxShadow: 'none',
    width: '100vw',
    overflowX: 'hidden',
    backgroundColor: 'white',
    borderBottom: '1px solid #e1e3e3',
    height: 60,
    '@media (max-width:900px)': {
        backgroundColor: 'transparent',
        borderBottom: '0px solid #e1e3e3',
    },
});

const ToolbarContainer = styled(Toolbar)({
    width: '100%',
    position: 'relative', // Needed for absolute positioning inside
    display: 'flex',
    alignItems: 'center',
    padding: '0 2rem',
    minHeight: '100% !important',
    height: '100%',
});

const Logo = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderRadius: '50px',
    cursor: 'pointer',
    height: 'auto',
    width: 'auto',
    '@media (max-width: 900px)': {
        marginLeft: '-30px',
    },
    '@media (min-width: 901px)': {
        marginLeft: '-10px',
    },
});

const MenuContainer = styled(Box)({
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2rem',
    backgroundColor: 'white',
    borderRadius: '50px',
});


const MenuItem = styled(Typography)({
    fontFamily: 'Poppins',
    fontWeight: 400,
    cursor: 'pointer',
    fontSize: '0.9rem',
    color: '#383838',
    '&:hover': {
        color: '#dc5454',
    },
});

const HoverableLogo = () => {
    const [isHovered, setIsHovered] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <Logo
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={scrollToTop}
        >
            <LogoIcon isHovered={isHovered} />
        </Logo>
    );
};

// Main header component with scroll-hide logic
const BlockHeader = () => {
    const isMobile = useMediaQuery('(max-width:900px)');
    const [showHeader, setShowHeader] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY && currentScrollY > 100) {
                setShowHeader(false); // Scrolling down
            } else {
                setShowHeader(true); // Scrolling up
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [lastScrollY]);

    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <Slide direction="down" in={showHeader} timeout={300}>
            <HeaderContainer position="fixed">
                <ToolbarContainer>
                    <HoverableLogo />
                    {!isMobile && (
                        <MenuContainer>
                            <MenuItem onClick={() => scrollToSection('block4')}>About us</MenuItem>
                            <MenuItem onClick={() => scrollToSection('block5')}>Our vision</MenuItem>
                            <MenuItem onClick={() => scrollToSection('block6')}>Team</MenuItem>
                            <MenuItem onClick={() => scrollToSection('partners')}>Partners</MenuItem>
                            <MenuItem onClick={() => scrollToSection('contact')}>Contact</MenuItem>
                        </MenuContainer>
                    )}
                </ToolbarContainer>
            </HeaderContainer>
        </Slide>
    );
};

export default BlockHeader;
